import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { CreditCard } from 'lucide-react'
import { DeleteConfirmDialog } from '@/components/dialog/common-dialog'
import { payStaffPayrollAction } from '@/redux/slice/staff-management/staff-attendance'
import { toast } from "react-hot-toast";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table'
import { Link } from 'react-router-dom'
import { blackUser } from "@/assets"

export function PStaffTable({ data = [], restaurantId }) {
  const dispatch = useDispatch()
  const [isPayDialogOpen, setIsPayDialogOpen] = useState(false)
  const [selectedPerson, setSelectedPerson] = useState(null)
  const [isPaying, setIsPaying] = useState(false)

  const handleConfirmPay = () => {
    if (!selectedPerson) return
    setIsPaying(true)
    dispatch(
      payStaffPayrollAction({
        restaurant_id: restaurantId,
        item_id: selectedPerson.id,
        payslip_id: selectedPerson.payslip_id
      })
    )
      .unwrap()
      .then((res) => {
        toast.success(res?.message || "Payment processed successfully.")
      })
      .catch((err) => {
        toast.error(err || "Payment failed.")
      })
      .finally(() => {
        setIsPaying(false)
        setIsPayDialogOpen(false)
        setSelectedPerson(null)
      })
  }

  return (
    <>
      <Table className='w-full'>
        <TableHeader>
          <TableRow>
            <TableHead className='w-[100px]'>ID</TableHead>
            <TableHead>Name</TableHead>
            <TableHead>Designations</TableHead>
            <TableHead>Phone</TableHead>
            <TableHead>Attendance</TableHead>
            <TableHead>Salary Type</TableHead>
            <TableHead>Amount</TableHead>
            <TableHead>Productivity Hours</TableHead>
            <TableHead className='text-right'>Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data.length > 0 ? (
            data.map((person, index) => (
              <TableRow key={person.id || index}>
                <TableCell className='font-medium'>{person.unique_id || person.id || "N/A"}</TableCell>
                <TableCell>
                  <div className='flex items-center gap-2'>
                    <img
                      src={person.avatar || blackUser}
                      alt={person.name}
                      className='w-8 h-8 rounded-full object-cover'
                    />
                    <span>{person.name || "N/A"}</span>
                  </div>
                </TableCell>
                <TableCell>{person.designation || "N/A"}</TableCell>
                <TableCell>{person.phone || "N/A"}</TableCell>
                <TableCell>{person.attendance_days !== undefined ? `${person.attendance_days} Days` : '0 Days'}</TableCell>
                <TableCell className="capitalize">{person.salary_type || "N/A"}</TableCell>
                <TableCell>{person.currency || "GBP"} {person.salary || 0}</TableCell>
                <TableCell>{person.productivity_hours !== undefined ? `${person.productivity_hours} Hours` : '0 Hours'}</TableCell>
                <TableCell className='text-right'>
                  <div className='flex items-center justify-end gap-2'>
                    {/* <Link to={'/backoffice/staff-management/payroll/details'}>
                      <span className='px-2 py-0.5 text-sm cursor-pointer text-black rounded bg-cyellow hover:bg-cyellow/90 transition-colors font-medium'>
                        Pay
                      </span>
                    </Link> */}
                    <span
                      onClick={() => {
                        setSelectedPerson(person)
                        setIsPayDialogOpen(true)
                      }}
                      className='px-2 py-0.5 text-sm cursor-pointer text-black rounded bg-cyellow hover:bg-cyellow/90 transition-colors font-medium'
                    >
                      Pay
                    </span>
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={9} className="text-center py-8 text-cwhite3">
                No payroll staff data found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <DeleteConfirmDialog
        isOpen={isPayDialogOpen}
        onClose={() => {
          setIsPayDialogOpen(false)
          setSelectedPerson(null)
        }}
        onConfirm={handleConfirmPay}
        icon={<CreditCard className="text-cyellow w-6 h-6" />}
        title="Confirm Payment"
        description={selectedPerson ? `Are you sure you want to process payment for ${selectedPerson?.name || "this staff member"}?` : ""}
        yesBtnTxt="Yes, Pay"
        noBtnTxt="Cancel"
        yesBtnClass="bg-cyellow hover:bg-cyellow/90 text-black font-semibold"
        isLoading={isPaying}
        autoCloseOnConfirm={false}
      />
    </>
  )
}

export default PStaffTable

